interface AppConfig {
  cognito: {
    region: string;
    userPoolId: string;
    clientId: string;
    domain: string;
    redirectUri: string;
    logoutUri: string;
  };
  apiBaseUrl: string;
}

function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === "") {
    throw new Error(
      `[config] Missing required env var: ${name}. Check frontend/.env.development.`,
    );
  }
  return value;
}

export const config: AppConfig = {
  cognito: {
    region: required("VITE_COGNITO_REGION", import.meta.env.VITE_COGNITO_REGION),
    userPoolId: required(
      "VITE_COGNITO_USER_POOL_ID",
      import.meta.env.VITE_COGNITO_USER_POOL_ID,
    ),
    clientId: required(
      "VITE_COGNITO_CLIENT_ID",
      import.meta.env.VITE_COGNITO_CLIENT_ID,
    ),
    domain: required(
      "VITE_COGNITO_DOMAIN",
      import.meta.env.VITE_COGNITO_DOMAIN,
    ),
    redirectUri: required(
      "VITE_COGNITO_REDIRECT_URI",
      import.meta.env.VITE_COGNITO_REDIRECT_URI,
    ),
    logoutUri: required(
      "VITE_COGNITO_LOGOUT_URI",
      import.meta.env.VITE_COGNITO_LOGOUT_URI,
    ),
  },
  apiBaseUrl: required(
    "VITE_API_BASE_URL",
    import.meta.env.VITE_API_BASE_URL,
  ),
};
